export default __webpack_public_path__ + "static/fR-b16ccb3e55757a4546ebfa2bafc35f69.svg";